import { Box, Typography, Avatar, Button } from '@mui/material';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import { useState } from 'react';
import EditToolsAndTechForm from './forms/edit-tools-and-tech-form';
import DeleteToolsAndTechForm from './forms/delete-tools-and-tech-form';
import { IPermissions, TabInfo } from '../../common/utils/interfaces';
import { EditIcon } from './styles/Style';
import { useAppSelector } from '../../../redux/hooks';

interface PropsType {
  tool: {
    id: string;
    name: string;
    department: string;
    image: string;
    createdById?: string;
  };
  editToolCallback: (toolId: string) => void;
  tabs: TabInfo[];
  permissions: IPermissions | undefined;
}

const ToolsAndTechnologiesCard = ({
  tool,
  editToolCallback,
  tabs,
  permissions
}: PropsType): JSX.Element => {
  const profileData = useAppSelector((state) => state.profileData.profileData);
  const [isEditModalVisible, setEditModalVisible] = useState(false);
  const [isDeleteModalVisible, setDeleteModalVisible] = useState(false);

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        padding: '14px 12px',
        border: '1px solid #C1C5CD',
        borderRadius: '12px',
        backgroundColor: '#FFFFFF',
        maxWidth: '350px'
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          gap: '9px'
        }}
      >
        <Box>
          {tool.image ? (
            <Avatar
              src={tool.image}
              sx={{
                width: '54px',
                height: '54px',
                borderRadius: '8px',
                backgroundColor: '#A15A0757'
              }}
              slotProps={{
                img: {
                  sx: {
                    objectFit: 'contain'
                  }
                }
              }}
            />
          ) : (
            <Avatar
              sx={{
                width: '54px',
                height: '54px',
                borderRadius: '8px',
                backgroundColor: '#A15A0757'
              }}
            >
              {tool.name[0]}
            </Avatar>
          )}
        </Box>
        <Typography
          sx={{
            fontFamily: 'Be Vietnam Pro',
            fontWeight: 600,
            fontSize: '18px',
            lineHeight: '20px',
            letter: '0.25px',
            color: '#000000'
          }}
        >
          {tool.name}
        </Typography>
      </Box>
      {((permissions?.tools.update && permissions?.tools.delete) ??
        tool.createdById === profileData?.id) && (
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'flex-end',
            alignItems: 'center',
            gap: '18px',
            marginTop: '12px'
          }}
        >
          <Button
            startIcon={
              <DeleteOutlineIcon sx={{ width: 'auto', height: '18px' }} />
            }
            sx={{
              color: 'red',
              display: 'flex',
              textTransform: 'none',
              borderRadius: '33px',
              height: '27px'
            }}
            onClick={() => {
              setDeleteModalVisible(true);
            }}
          >
            Delete
          </Button>
          <Button
            startIcon={<EditIcon />}
            sx={{
              display: 'flex',
              alignItems: 'center',
              textTransform: 'none',
              fontWeight: 600,
              background: '#E2ECF6',
              borderRadius: '33px',
              height: '27px',
              paddingX: '15px'
            }}
            onClick={() => {
              setEditModalVisible(true);
            }}
          >
            Edit
          </Button>
        </Box>
      )}

      <EditToolsAndTechForm
        open={isEditModalVisible}
        handleClose={() => setEditModalVisible(false)}
        id={'fake id'}
        comment=""
        currentTool={tool}
        editToolCallback={editToolCallback}
        tabs={tabs}
      />
      <DeleteToolsAndTechForm
        open={isDeleteModalVisible}
        handleClose={() => setDeleteModalVisible(false)}
        deleteToolCallback={editToolCallback}
        id={tool.id}
      />
    </Box>
  );
};

export default ToolsAndTechnologiesCard;
